import { Component, OnInit, ViewChild } from '@angular/core';

import { UserService } from './providers/user/user.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from './app.constants';
import { CustomIconsService } from './core/modules/custom-icons/services/custom-icons.service';
import { UiOperationService } from './core/modules/custom-navigation/services/ui-operation.service';
import { takeUntil, tap } from 'rxjs/operators';
import { DestroyableComponent } from './core/utils/destroyable.component';
import { filterCommands, filterOperations } from './core/modules/custom-navigation';
import { NavigateByPathCommand } from './core/modules/custom-navigation/models/commands/navigate-by-path.command.model';
import { InviteDriverOperation } from './core/modules/custom-navigation/models/operations/invite-driver.operation.model';
import { InviteDispatcherOperation } from './core/modules/custom-navigation/models/operations/Invite-dispatcher.operation.model';
import { merge } from 'rxjs';
import { CreateLeadOperation } from './core/modules/custom-navigation/models/operations/create-lead.operation.model';
import { LoadingService } from './providers/loading/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends DestroyableComponent implements OnInit {
  @ViewChild('drawer') drawer;

  constructor(
    public userService: UserService,
    public loadingService: LoadingService,
    private readonly router: Router,
    private readonly customIconsService: CustomIconsService,
    private readonly uiOperationService: UiOperationService,
  ) {
    super();
  }

  ngOnInit() {
    merge(
      this.uiOperationService.operations$.pipe(filterOperations(InviteDriverOperation)),
      this.uiOperationService.operations$.pipe(filterOperations(InviteDispatcherOperation)),
      this.uiOperationService.operations$.pipe(filterOperations(CreateLeadOperation))
    ).pipe(
      takeUntil(this.onDestroy),
      filterCommands(NavigateByPathCommand),
      tap(operation => this.uiOperationService.next(operation)),
      tap(({ payload }) => this.router.navigateByUrl(payload.path))
    ).subscribe();

    this.customIconsService.initialize();
    this.userService.toggleSidebar
      .subscribe(() => {
        setTimeout(
          () => {
            if (this.drawer) {
              this.drawer.close();
            }
          },
          100);
      });
  }

  public toggleMenu() {
    this.drawer.toggle();
  }

  public isLoginLayout() {
    return [
      `/${APP_ROUTES.reset_password}`,
      `/${APP_ROUTES.auth}`,
      `/${APP_ROUTES.register_carrier_final_step}`,
    ].includes(this.router.url);
  }
}
